"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
exports.default = (0, styles_1.styled)('div')({
    opacity: '0.7',
    fontSize: 12,
    lineHeight: '16px',
    paddingTop: 8,
});
